<template>
  <div>
    <div v-if="isPublicOrMember">
      <div class="card-body mb-0">
        <div class="row mb-1">
          <div class="h3 col-md-3 col-sm-12">Resources</div>
          <div class="input-group col-md-6 col-sm-12">
            <b-input-group-prepend>
                  <span class="btn btn-secondary" title="Search Project Resources">
                    <i v-if="!isBusy" class="fas fa-search"></i>
                    <i v-if="isBusy" class="fas fa-spinner fa-spin"></i>
                  </span>
            </b-input-group-prepend>
            <b-form-input
              placeholder="Search Project Resources"
              name="search"
              type="search"
              v-model="searchText"
              debounce="1000"
            ></b-form-input>
            <div class="input-group-append" v-if="searchText">
              <b-button @click="searchText = ''"
              ><i class="fas fa-times-circle"></i>
              </b-button>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="btn-group d-flex">
              <div class="btn btn-secondary btn-sm" @click="setResourceShowCard(false)">
                <i class="fas fa-list"></i> List
              </div>
              <div class="btn btn-tertiary btn-sm" @click="setResourceShowCard(true)">
                <i class="far fa-images fa-1x"></i> Card
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2 p-0 justify-content-end">
          <div class="col-xs-3 col-md-4 col-lg-3">
            <ProjectNotificationStatus class="text-right" v-if="isMember" notification-type="resource"></ProjectNotificationStatus>
          </div>
        </div>
      </div>
        <ResourceTable class="mt-0"></ResourceTable>
    </div>
    <RequiresMember v-else page="Resources"></RequiresMember>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RequiresMember from "../tabpermission/requiresMember.vue";
import ResourceTable from "./resourceTable.vue";
import TagsPopular from "../resources/tagsPopular.vue";
import TagsFilter from "../resources/tagsFilter.vue";
import ProjectNotificationStatus from "../notifications/ProjectNotificationStatus.vue";

export default {
  name: "Resources",
  components: {
    ProjectNotificationStatus,
    RequiresMember,
    ResourceTable,
    TagsFilter,
    TagsPopular,
  },
  data() {
    return {
      isBusy: false,
    };
  },
  created() {},
  watch: {},
  destroyed() {},
  computed: {
    ...mapGetters({
      projectId: "project/get/id",
      isPublicOrMember: "project/get/isPublicOrMember",
      isManager: "project/get/isManager",
      isMember: "project/get/isMember",
      resourceShowCard: "project/get/resourceShowCard",
      resourceSearch: "project/get/resourceSearch",
    }),
    searchText: {
      get() {
        return this.resourceSearch
      },
      set(newValue) {
        this.setResourceTableSearch(newValue)
      }
    },
  },
  methods: {
    ...mapActions({
      setResourceShowCard: "project/get/setResourceShowCard",
      setResourceTableSearch: "project/get/setResourceTableSearch",
    }),
    toggleView() {
      this.setResourceShowCard(!this.resourceShowCard)
    },
  }
};
</script>

<style></style>
